import { create } from 'zustand';
import { api, fromUnix, toQueryString } from '@/lib/api';
import type { ApiResponse, AuditLogEntry } from '@nexus/shared/types';

interface AuditState {
  entries: AuditLogEntry[];
  total: number;
  isLoading: boolean;
  error: string | null;
  fetch: (params?: Record<string, string | number | undefined>) => Promise<void>;
  clearError: () => void;
}

function convert(e: Record<string, unknown>): AuditLogEntry {
  return {
    ...e,
    createdAt: fromUnix(e.createdAt as number),
    changes: typeof e.changes === 'string' ? JSON.parse(e.changes as string) : e.changes,
  } as AuditLogEntry;
}

export const useAuditStore = create<AuditState>((set) => ({
  entries: [],
  total: 0,
  isLoading: false,
  error: null,

  fetch: async (params) => {
    set({ isLoading: true, error: null });
    try {
      const res = await api.get<ApiResponse<AuditLogEntry[]>>(`/api/audit${toQueryString(params)}`);
      set({
        entries: (res.data ?? []).map(e => convert(e as unknown as Record<string, unknown>)),
        total: res.meta?.total ?? 0,
        isLoading: false,
      });
    } catch (err: unknown) {
      set({ error: (err as Error).message, isLoading: false });
    }
  },

  clearError: () => set({ error: null }),
}));
